import { useState } from 'react';
import { FaEdit } from 'react-icons/fa';

import ComponentModal from '../../../reusable/component-modal/component-modal.component';
import UpdateShippingProvider from './update/update-shipping-provider.component';

import {
  MainContainer,
  ProviderOptionsContainer,
  ProviderDataContainer,
  ProviderContainerRow,
  ProviderDataTitle,
  ProviderDataText
} from './shipping-provider-display.styles';

const ShippingProviderDisplay = ({ provider, getProvider }) => {
  const [showUpdate, setShowUpdate] = useState(false);

  return (
    <MainContainer>
      <ComponentModal
        isOpen={showUpdate}
        onClose={() => setShowUpdate(false)}
        title="Update Shipping Provider"
      >
        <UpdateShippingProvider
          provider={provider}
          getProvider={getProvider}
          setShowUpdate={setShowUpdate}
        />
      </ComponentModal>

      <ProviderOptionsContainer>
        <FaEdit onClick={() => setShowUpdate(true)} />
      </ProviderOptionsContainer>

      <ProviderDataContainer>
        <ProviderContainerRow>
          <ProviderDataTitle>Name:</ProviderDataTitle>
          <ProviderDataText>{provider.name}</ProviderDataText>
        </ProviderContainerRow>
        <ProviderContainerRow>
          <ProviderDataTitle>Code:</ProviderDataTitle>
          <ProviderDataText>{provider.code}</ProviderDataText>
        </ProviderContainerRow>
        <ProviderContainerRow>
          <ProviderDataTitle>Tracking Template:</ProviderDataTitle>
          <ProviderDataText>{provider.trackingUrlTemplate || '—'}</ProviderDataText>
        </ProviderContainerRow>
      </ProviderDataContainer>
    </MainContainer>
  );
};

export default ShippingProviderDisplay;